const images = {
  intro_mobile: require("./images/intro_mobile.jpg"),
  mail: require("./images/mail.svg").default,
  logo: require("./images/logo.png"),
  like: require("./images/like.svg").default,
  good: require("./images/good.svg").default,
  error: require("./images/error.svg").default,
  indicationLike: require("./images/indicationLike.svg").default,
  indicationDislike: require("./images/indicationDislike.svg").default,
  closeCross: require("./images/closeCross.svg").default,
  contact: require("./images/contact.svg").default,
  truefalse: {
    fr: require("./images/truefalse_fr.gif"),
    es: require("./images/truefalse_en.gif"),
    en: require("./images/truefalse_en.gif"),
  },
  wall_waiting: require("./images/wall_waiting.png"),
  shop_waiting_default: require("./images/shop_waiting_default.jpg"),
  shop_waiting_es: require("./images/shop_waiting_es.jpg"),
  logo_Default: require("./images/theme/Default/logo_oneretail.png"),
  logo_noel: require("./images/theme/noel/logo_oneretail_noel.png"),
  logo_christmas: require("./images/theme/Christmas/logo_oneretail_christmas.png"),
  logo_christmas2025: require("./images/theme/Christmas/logo_oneretail_christmas.png"),
  different_logo_christmas2025: require("./images/theme/noel/logo_oneretail_noel.png"),
  backround_noel_login: require("./images/theme/noel/oneretail_login_noel.jpg"),
  backround_noel_footer: require("./images/theme/noel/oneretail_footer_noel.jpg"),
  we_are_lol_black: require("./images/lol_logo_black.png"),
  icon_user: require("./images/icon-user.jpg"),
  womens_sponroship: require("./images/parrainage/womens_sponsorship.png"),
  icon_sponsorship: require("./images/parrainage/icon_sponsorship.png"),
  maintenance: require("./images/maintenance.png"),

  //images profile
  orders: require("./images/profil/orders.svg").default,

  //img brands
  arrow_left_white: require("./images/brands/arrow-left-white.svg").default,
  arrow_left_black: require("./images/brands/arrow-left-black.svg").default,
  love_icon_white: require("./images/brands/love-icon.svg").default,
  article_icon_black: require("./images/brands/article-icon-black.svg").default,
  article_icon_grey: require("./images/brands/article-icon-grey.svg").default,
  formation_icon_black: require("./images/brands/formation-icon-black.svg")
    .default,
  formation_icon_grey: require("./images/brands/formation-icon-grey.svg")
    .default,
  produit_icon_black: require("./images/brands/produit-icon-black.svg").default,
  produit_icon_grey: require("./images/brands/produit-icon-grey.svg").default,
  video_icon_black: require("./images/brands/video-icon-black.svg").default,
  video_icon_grey: require("./images/brands/video-icon-grey.svg").default,
  tools_icon_grey: require("./images/brands/tools-icon-grey.svg").default,
  tools_icon_black: require("./images/brands/tools-icon-black.svg").default,
  bg_none: require("./images/brands/bg-none.png"),
  product_brand_1: require("./images/brands/test-product-by-brand-1.png"),
  product_brand_2: require("./images/brands/test-product-by-brand-2.png"),
  points_stars: require("./images/brands/points_stars.png"),
  chrono: require("./images/brands/chrono.png"),
  default_category_bg: require("./images/brands/default-category-bg.png"),

  //images wall
  wall_icon_list: require("./images/wall/wallList-icon.png"),
  wall_icon_list_selected: require("./images/wall/wallList-icon-selected.png"),
  wall_icon_filter: require("./images/wall/wall-filter.png"),
  icon_video_white: require("./images/wall/icon_video_white.svg").default,
  icon_multiple: require("./images/wall/icon_multiple.svg").default,
  checked_black: require("./images/wall/checked_black.png"),
  camera: require("./images/wall/camera.png"),

  //images shop
  cart_ok: require("./images/shop/cart_ok.svg").default,
  order_confirm: require("./images/shop/order_confirm.svg").default,

  funnel: require("./images/funnel.svg").default,
  adjustements_vertical: require("./images/adjustements-vertical.svg").default,
  chevron_down: require("./images/chevron-down.svg").default,
  arrow_left: require("./images/arrow-left.svg").default,
  article: require("./images/filters/news.png"),
  product_catalog: require("./images/filters/product_catalog_document.png"),
  video: require("./images/filters/video.png"),
  course: require("./images/filters/course.png"),
  filter: require("./images/filters/picto_filter.png"),
  filter_selected: require("./images/filters/picto_filter_selected.png"),
  sort_on: require("./images/filters/picto_sort_on.png"),
  sort_off: require("./images/filters/picto_sort_off.png"),
  luxe_content: require("./images/filters/luxe_content.png"),
  onehr_content: require("./images/filters/onehr_content.png"),
  warning: require("./images/warning.svg").default,
  checkmark: require("./images/checkmark.svg").default,
};

export default images;
